import {
  Component,
  Logger,
  Query,
  SystemType,
  World,
  Color,
  vec,
  Entity,
  Actor,
  ExcaliburGraphicsContext,
} from "excalibur";

export class HealthComponent extends Component {
  killed: boolean = false;
  constructor(
    public currentHp: number,
    public maxHp: number,
    public absorbAllDamageOnDeath: boolean = false,
  ) {
    super();
  }

  // Returns actual damage done
  damage(dmg: number): number {
    const actualDmg = Math.min(this.currentHp, dmg);
    this.currentHp -= actualDmg;
    if (this.currentHp <= 0 && this.absorbAllDamageOnDeath) return dmg;
    return actualDmg;
  }
}

export class HealthSystem {
  query: Query<typeof HealthComponent>;
  private _logger = Logger.getInstance();

  constructor(world: World) {
    this.query = world.query([HealthComponent]);

    // Subscribe to entities being added with HealthComponent
    this.query.entityAdded$.subscribe((entity) => {
      const healthComponent = entity.get(HealthComponent);
      this.initializeHealthbar(entity, healthComponent);
    });
  }

  //public priority = 99;
  // Run this system in the "update" phase
  public systemType = SystemType.Update;
  public update(_delta: number) {
    for (const entity of this.query.entities) {
      const hc = entity.get(HealthComponent);

      if (!hc.killed && hc.currentHp <= 0) {
        this._logger.info(entity.name, "die");
        hc.killed = true;
        entity.kill();
      }
    }
  }

  private initializeHealthbar(
    entity: Entity<HealthComponent>,
    healthComponent: HealthComponent,
  ) {
    (entity as Actor).on("postdraw", ({ ctx }) => {
      if (!healthComponent.killed)
        this.drawHealthbar(ctx, entity, healthComponent);
    });
  }

  private drawHealthbar(
    gfx: ExcaliburGraphicsContext,
    entity: Entity,
    healthComponent: HealthComponent,
  ) {
    if (
      healthComponent.currentHp == healthComponent.maxHp ||
      healthComponent.killed
    )
      return;
    const healthPercent = healthComponent.currentHp / healthComponent.maxHp;

    // Healthbar dimensions - smaller for mobs
    const isMob = entity.name?.includes("hopper");
    const barWidth = isMob ? 8 : 24;
    const barHeight = isMob ? 2 : 4;
    const barOffset = vec(-4, -(entity as Actor).height / 2 - 8);

    // Background bar (dark gray)
    gfx.drawRectangle(barOffset, barWidth, barHeight, Color.fromHex("#333333"));

    // Foreground bar (health color)
    const healthColor = this.getHealthColor(healthPercent);
    const healthBarWidth = barWidth * healthPercent;
    gfx.drawRectangle(barOffset, healthBarWidth, barHeight, healthColor);
  }

  private getHealthColor(healthPercent: number): Color {
    if (healthPercent > 0.6) {
      return Color.Green;
    } else if (healthPercent > 0.3) {
      return Color.Yellow;
    } else {
      return Color.Red;
    }
  }
}
